import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { SeeProducts } from "../../../admin/actions/productActions";
import { useTokenCallback } from "../../../utils/hooks/useTokenCallback";
import { getEcopointsBuy, getEcopointsRedeem } from "../../../actions/marketPlaceActions";
import { getConsolidateProducts, getBestSellerProducts } from '../../../admin/actions/transferActions';
import ShowCaseView from '../../../containers/MarketPlace/ShowCase/ShowCase';
import { getLimitReports } from '../../../admin/actions/reportActions';
import { SeeCompleteCategories } from '../../../admin/actions/pCategoriesActions';
import { SeeSubCategoriesById } from '../../../admin/actions/subCategoriesActions';
import localStorage from "../../../utils/hooks/useLocalStorage";




const MarketPlace = () => {
  const { consolidateProducts } = useSelector((state) => state.tranfers);
  const { bestSellerProducts } = useSelector((state) => state.tranfers);
  const { pointsToRedeem,pointsBuy } = useSelector((state) => state.marketPlace);
  const { listOfReportsLimit } = useSelector((state) => state.postAdmin);
  const { completeCategoriesList } = useSelector(state => state.categoriesAdmin)
  const { subCategoriesList } = useSelector(state => state.subCategoriesAdmin)

  const [categoryState, setCategoryState] = useState('');
  const [subCategoryState, setSubCategoryState] = useState('');
  const [page, setPage] = useState(0);
  const [skipConsolidateProducts, setSkipConsolidateProducts] = useState(0);
  const [searchState, setSearchState] = useState("");


  const pageSkip = 50;
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(SeeCompleteCategories())
    dispatch(getEcopointsRedeem())
    dispatch(getLimitReports())

    if (localStorage().getItem("typeProfile") ==="franchise") {
      dispatch(getEcopointsBuy(localStorage().getItem("idProfile")))
    }
    return () => {

    }
  }, [])


  useEffect(() => {
    dispatch(SeeSubCategoriesById(categoryState))
  }, [categoryState]);

  useTokenCallback(() => {
    dispatch(getBestSellerProducts(page))
    dispatch(getConsolidateProducts(skipConsolidateProducts, searchState, categoryState,
      subCategoryState));
  }, [page])

  useEffect(() => {
    dispatch(getConsolidateProducts(skipConsolidateProducts, searchState, categoryState,
      subCategoryState));
  }, [categoryState, subCategoryState, searchState]);





  return (
    <ShowCaseView
      categoryState={categoryState}
      setCategoryState={setCategoryState}
      subCategoryState={subCategoryState}
      setSubCategoryState={setSubCategoryState}
      searchState={searchState}
      setSearchState={setSearchState}
      ecoPrice={listOfReportsLimit?.ecoPrice}
      bestSellerProducts={bestSellerProducts}
      consolidateProducts={consolidateProducts}
      setPage={setPage}
      categories={completeCategoriesList}
      subCategories={subCategoriesList}
      setSkipConsolidateProducts={setSkipConsolidateProducts}
      pageSkip={pageSkip}
      pointsBuy={pointsBuy}
      pointsToRedeem={pointsToRedeem} />
  )
}

export default MarketPlace
